import React from 'react';

import { TestComponent } from '@components';
import { render } from '@testing-library/react';
import { Anything } from '@types';

interface TestHelperHookTestInput<T> {
	hookFn: () => T;
	state?: Record<string, Anything>;
}

interface TestHelperServiceHookTestInput<T> {
	hookFn: () => T;
	apiMethodName: string;
	successResponse?: Anything;
	state?: Record<string, Anything>;
}

export class TestHelper {
	static hookTest = <T,>(input: TestHelperHookTestInput<T>): T => {
		const { hookFn, state } = input;
		const returnVal = {};

		const TestComp: React.FC = () => {
			Object.assign(returnVal, hookFn());
			return null;
		};

		render(
			<TestComponent state={state}>
				<TestComp />
			</TestComponent>
		);

		return returnVal as Anything;
	};

	static serviceHookTest = async <T,>(input: TestHelperServiceHookTestInput<T>): Promise<T> => {
		const { hookFn, state } = input;
		const returnVal: Anything = {};

		const TestComp: React.FC = () => {
			Object.assign(returnVal, hookFn());
			return null;
		};

		render(
			<TestComponent state={state}>
				<TestComp />
			</TestComponent>
		);

		return returnVal.fetch();
	};
}
